export default "{\n    \"selfServiceLabel\": \"Plan en libre-service\",\n    \"managedByResqLabel\": \"Géré par ResQ\"\n}\n"